export default __webpack_public_path__ + "static/media/home-logo.c9ccc02a.svg";